import { gql } from '@apollo/client';

const deleteStartWork = gql`
  mutation deleteStartWork($_id: String) {
    deleteStartWork(_id: $_id) {
      ok
      message
      error
    }
  }
`;

export default deleteStartWork;
